module.exports = __webpack_public_path__ + "img/huaweilogo_homepage.0e787941.png";